import {
  useIsBreakpoint,
  useIsBreakpointOrSmaller,
  useIsBreakpointOrLarger,
  useIsTouchDevice,
} from '../Components/BreakpointContext/BreakpointContextUtils';

/** Edit controls should use the fullscreen edit mode view, active on touch-oriented layouts */
export const useFullscreenView = (): boolean => {
  return useIsTouchDevice();
};

export const useIsExtraSmallScreen = (): boolean => {
  return useIsBreakpoint('xs');
};

export const useIsSmallScreen = (): boolean => {
  return useIsBreakpointOrSmaller('sm');
};

export const useIsLargeScreen = (): boolean => {
  return useIsBreakpointOrLarger('md');
};
